<template>
  <div>
    <page-header title="ویرایش پست"></page-header>

    <crud-generator v-if="post" :fields="fields" @submit="submit" :current-values="post" name="posts"></crud-generator>
  </div>
</template>

<script>
import PageHeader from "@/components/General/PageHeader";
import CrudGenerator from "@/components/General/CrudGenerator";

export default {
  name: "UpdatePost",

  components: {CrudGenerator, PageHeader},

  data() {
    return {
      fields: [],
      post: null,
    }
  },

  mounted() {
    this.getPost()
  },

  methods: {
    getPost() {
      this.$store.dispatch("singlePost", this.$route.params.fa_slug)
      .then((res) => {
        this.post = res.data
        this.fillFields()
      })
    },

    fillFields() {
      this.fields = [
        {
          name: 'fa_title',
          label: 'عنوان',
          cols: 4,
          type: 'text',
          direction: 'rtl',
        },
        {
          name: 'fa_short_description',
          label: 'توضیح کوتاه',
          cols: 8,
          type: 'text',
          direction: 'rtl'
        },
        {
          name: 'fa_content',
          label: 'متن',
          cols: 12,
          type: 'ckeditor',
          direction: 'rtl'
        },
        {
          name: 'fa_meta_title',
          label: 'عنوان متا',
          cols: 6,
          type: 'text',
          direction: 'rtl'
        },
        {
          name: 'fa_meta_keywords',
          label: 'کلیدواژه های متا',
          cols: 6,
          type: 'text',
          direction: 'rtl'
        },
        {
          name: 'fa_meta_descriptions',
          label: 'توضیحات متا',
          cols: 12,
          type: 'text',
          direction: 'rtl'
        },

        {
          name: 'en_title',
          label: 'Title',
          cols: 4,
          type: 'text',
          direction: 'ltr',
        },
        {
          name: 'en_short_description',
          label: 'Short Description',
          cols: 8,
          type: 'text',
          direction: 'ltr'
        },
        {
          name: 'en_content',
          label: 'Content',
          cols: 12,
          type: 'text',
          direction: 'ltr'
        },
        {
          name: 'en_meta_title',
          label: 'Meta Title',
          cols: 6,
          type: 'text',
          direction: 'ltr'
        },
        {
          name: 'en_meta_keywords',
          label: 'Meta Keywords',
          cols: 6,
          type: 'text',
          direction: 'ltr'
        },
        {
          name: 'en_meta_descriptions',
          label: 'Meta Description',
          cols: 12,
          type: 'text',
          direction: 'ltr'
        },

        {
          name: 'image',
          label: 'تصویر',
          cols: 4,
          type: 'image',
          preview: 'image_url',
          previewLabel: 'تصویر فعلی',
        },
      ]
    },

    submit(values) {
      this.$store.dispatch("updatePost", {data: values, identifier: this.$route.params.fa_slug})
          .then(() => {
            this.$router.push('/posts');
          })
    },
  }
}
</script>

<style scoped>

</style>